import queryString from "query-string";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader } from "../../../components";

import Form from "./Form";
import { objectFromResponse as responseObject } from "../../brand components/brand details components/brandDetailObject";
import { useAxios, useComponent } from "../../../hooks";
import {
  connectionLists,
  createCampaignObject,
  getAudienceDetails,
  objectFromResponse,
} from "../create campaign components/campaign form components/campaignObject";
import { audienceObject } from "../create campaign components/audience details components/audienceObjects";

export default function SuperadminCampaignDetails() {
  const axios = useAxios();
  const params = useParams();
  const { loader } = useComponent();

  const campaignID = params.campaignID || "";
  const brandID = queryString.parse(window.location.search).brandID;

  const [retry, setRetry] = useState({});
  const [agents, setAgents] = useState([]);
  const [brandDetails, setBrandDetails] = useState({
    data: {},
    icon: "",
  });
  const [editState, setEditState] = useState(false);
  const [connections, setConnections] = useState([]);
  const [audienceSize, setAudienceSize] = useState();
  const [preferredChannels, setPreferedChannels] = useState([]);
  const [formData, setFormData] = useState(createCampaignObject);
  const [audienceData, setAudienceData] = useState(audienceObject);
  const { categories, userID } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    const fetchData = async () => {
      loader.start(campaignID ? 4 : 2);

      try {
        const channelsRes = await axios({
          url: "/get/campaign/preferredChannels",
        });
        if (channelsRes.status) {
          setPreferedChannels(channelsRes.data);

          if (channelsRes.data.length > 0) {
            const agentsRes = await axios({
              url: "/get/brandAgentDetails",
              method: "POST",
              data: { brand_id: brandID },
            });
            if (agentsRes.status) {
              const data = {};
              agentsRes.data.forEach((agent) => {
                const key = Object.keys(agent)[2];
                data[key] = agent[key];
              });
              setAgents(data);
            }
          }
        }
        loader.apiComplete();

        if (campaignID) {
          const campaignRes = await axios({
            url: `/user/brand/getCampaign?brandId=${brandID}&campaignId=${campaignID}`,
          });

          if (campaignRes.status) {
            const audienceId = campaignRes.data.audience.audience_id;

            const [audienceRes, sizingRes, creativesRes] = await Promise.all([
              axios({ url: `/brand/getDetailsOfAudience/${audienceId}` }),
              axios({
                url: "/get/audienceSizing",
                method: "POST",
                data: {
                  brand_id: brandID,
                  campaign_id: campaignID,
                  audience_id: audienceId,
                },
                disableRedirect: true,
                disableError: true,
              }),
              axios({
                url: `/user/brand/campaign/creatives?campaignId=${campaignID}`,
              }),
            ]);

            if (audienceRes.status) {
              setAudienceData(getAudienceDetails(audienceRes.data));
            }
            if (sizingRes.status) {
              setAudienceSize(sizingRes.data);
            }

            if (creativesRes.status) {
              const campaignData = {
                ...campaignRes.data,
                creatives: creativesRes.data,
              };
              setConnections(
                connectionLists(campaignRes.data?.connections || [])
              );
              if (campaignData.status !== "CREATED") setEditState(false);
              setFormData(objectFromResponse(campaignData));
              setBrandDetails({
                state: false,
                data: responseObject(campaignData.brand),
              });
            }

            loader.apiComplete(3);
          }
        }
      } catch (error) {
        console.error(error);
        loader.apiComplete();
      }
    };

    fetchData();
  }, [brandID, axios, loader, campaignID, userID]);

  return (
    <Loader>
      <Form
        agents={agents}
        preferredChannels={preferredChannels}
        audienceSizing={audienceSize}
        setAudienceSizing={setAudienceSize}
        retry={retry}
        setRetry={setRetry}
        categories={categories}
        formData={formData}
        editState={editState}
        setEditState={setEditState}
        audienceData={audienceData}
        connections={connections}
        brandDetails={brandDetails}
        setBrandDetails={setBrandDetails}
        component={"superadmin"}
        setConnections={setConnections}
      />
    </Loader>
  );
}
